"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Label = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _Field = _interopRequireDefault(require("../Field"));
var _Label = _interopRequireDefault(require("../Label"));
require("./PasswordToggle.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["Hide"] = "Hide";
  Label["Show"] = "Show";
  return Label;
}({});
/**
 * The props for the Password Toggle component.
 */
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Password Toggle](https://docs.vanillaframework.io/base/forms/#password-toggle).
 *
 * It can be used when an input needs to obscure its value, whilst giving the user a way to reveal it if needed.
 */
const PasswordToggle = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    caution,
    className,
    error,
    help,
    id,
    label,
    readOnly,
    required,
    success,
    type,
    wrapperClassName,
    ...inputProps
  } = _ref;
  const [isPassword, setIsPassword] = (0, _react.useState)(true);
  const validationId = (0, _react.useId)();
  const helpId = (0, _react.useId)();
  const hasError = !!error;
  const defaultPasswordToggleId = (0, _react.useId)();
  const passwordToggleId = id || defaultPasswordToggleId;
  const togglePassword = () => {
    if (isPassword) {
      setIsPassword(false);
    } else {
      setIsPassword(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Field.default, {
    caution: caution,
    className: wrapperClassName,
    error: error,
    help: help,
    helpId: helpId,
    required: required,
    success: success,
    validationId: validationId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "password-toggle"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    "aria-describedby": [help ? helpId : null, success ? validationId : null].filter(Boolean).join(" "),
    "aria-errormessage": hasError ? validationId : null,
    "aria-invalid": hasError,
    className: (0, _classnames.default)("p-form-validation__input", className),
    id: passwordToggleId,
    readOnly: readOnly,
    ref: ref,
    type: isPassword ? "password" : "text"
  }, inputProps)), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-form-password-toggle"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    forId: passwordToggleId,
    required: required
  }, label), /*#__PURE__*/_react.default.createElement(_Button.default, {
    appearance: "base",
    type: type ? type : "button",
    className: "u-no-margin--bottom",
    hasIcon: true,
    "aria-controls": id,
    "aria-live": "polite",
    onClick: () => togglePassword()
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-form-password-toggle__label"
  }, isPassword ? Label.Show : Label.Hide), /*#__PURE__*/_react.default.createElement("i", {
    className: isPassword ? "p-icon--show" : "p-icon--hide"
  })))));
});
var _default = exports.default = PasswordToggle;